import { Button, Drawer, DrawerBody, DrawerFooter, DrawerHeader } from "@/components";
import type { ApiDeviceProfile } from "../../_types/device-profiles.types";
import styles from "./PolicyDetailDrawer.module.scss";

type PolicyDetailDrawerProps = {
  policyId: string | null;
  policies: ApiDeviceProfile[];
  isOpen: boolean;
  onClose: () => void;
  onRequestDelete: (profile: ApiDeviceProfile) => void;
};

export const PolicyDetailDrawer = ({
  policyId,
  policies,
  isOpen,
  onClose,
  onRequestDelete,
}: PolicyDetailDrawerProps) => {
  const policy = policyId != null ? policies.find((p) => p.id === policyId) : undefined;

  const title = policy?.name ?? "Profile";
  const subtitle =
    policy != null ? `Prototype · Version ${policy.configVersion}` : "Prototype / Preview";

  return (
    <Drawer isOpen={isOpen} onClose={onClose} ariaLabel="Profile details (prototype)">
      <DrawerHeader title={title} subtitle={subtitle} onClose={onClose} />
      <DrawerBody>
        <div className={styles["comp"]}>
          {!policy && policyId != null ? (
            <p className={styles["comp__error"]}>
              Profile not found in the current prototype list. Try closing and reopening.
            </p>
          ) : null}

          {policy ? (
            <>
              <p className={styles["comp__hint"]}>
                Prototype / Preview — this profile exists only in page memory and cannot be assigned
                to real devices.
              </p>
              <div className={styles["comp__grid"]}>
                <div style={{ gridColumn: "1 / -1" }}>
                  <div className={styles["comp__label"]}>Description</div>
                  <div className={styles["comp__value"]}>{policy.description ?? "—"}</div>
                </div>
                <div>
                  <div className={styles["comp__label"]}>Updated</div>
                  <div className={styles["comp__value"]}>
                    {new Intl.DateTimeFormat(undefined, {
                      dateStyle: "medium",
                      timeStyle: "short",
                    }).format(new Date(policy.updatedAt))}
                  </div>
                </div>
              </div>

              <div>
                <div className={styles["comp__label"]}>Config</div>
                <pre className={styles["comp__pre"]}>{JSON.stringify(policy.config, null, 2)}</pre>
              </div>
            </>
          ) : null}
        </div>
      </DrawerBody>
      {policy ? (
        <DrawerFooter>
          <Button type="button" variant="danger" onClick={() => onRequestDelete(policy)}>
            Delete profile
          </Button>
          <Button type="button" variant="secondary" onClick={onClose}>
            Close
          </Button>
        </DrawerFooter>
      ) : null}
    </Drawer>
  );
};
